/* Pawzi National Day page. Isolated from the homepage offers component. */
(() => {
  if (customElements.get('pawzi-nd-page')) return;

  class PawziNDPage extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.cards = [...this.querySelectorAll('[data-pndp-card]')];
      this.grid = this.querySelector('[data-pndp-grid]');
      this.pet = 'cat';
      this.group = 'all';
      const requestedPet = new URL(location.href).searchParams.get('pet');
      if (['cat', 'dog', 'bird'].includes(requestedPet)) this.pet = requestedPet;

      this.addEventListener('click', event => {
        const petButton = event.target.closest('[data-pndp-pet]');
        const groupButton = event.target.closest('[data-pndp-group]');
        if (petButton) {
          this.pet = petButton.dataset.pndpPet;
          this.group = 'all';
          this.update();
        }
        if (groupButton) {
          this.group = groupButton.dataset.pndpGroup;
          this.update();
        }
      }, { signal });

      this.addEventListener('submit', event => {
        if (!event.target.matches('.pndp-form')) return;
        event.preventDefault();
        this.addToCart(event.target);
      }, { signal });

      this.update();
      this.initCountdown();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearInterval(this.timer);
    }

    update() {
      const matches = this.cards.filter(card => {
        const pets = card.dataset.pets.split(' ').filter(Boolean);
        const groups = card.dataset.groups.split(' ').filter(Boolean);
        const petMatches = pets.includes(this.pet);
        const groupMatches = this.group === 'all' || (this.group === 'expiry' ? card.dataset.expiry === '1' : groups.includes(this.group));
        return petMatches && groupMatches;
      });

      this.cards.forEach(card => { card.hidden = true; });
      matches.sort((a, b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true'));
      matches.forEach(card => {
        card.hidden = false;
        this.grid.append(card);
      });

      this.dataset.pet = this.pet;
      this.querySelectorAll('[data-pndp-pet]').forEach(button => button.setAttribute('aria-selected', String(button.dataset.pndpPet === this.pet)));
      this.querySelectorAll('[data-pndp-group]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pndpGroup === this.group)));
      const title = this.dataset[`${this.pet}Title`];
      if (title) this.querySelector('[data-pndp-title]').textContent = title;
      this.querySelector('[data-pndp-count]').textContent = String(matches.length);
      this.querySelector('[data-pndp-empty]').hidden = matches.length !== 0;

      const url = new URL(location.href);
      url.searchParams.set('pet', this.pet);
      history.replaceState({}, '', url);
    }

    initCountdown() {
      const clock = this.querySelector('[data-pndp-countdown]');
      if (!clock) return;
      const target = Date.parse(clock.dataset.end);
      if (!Number.isFinite(target)) {
        clock.hidden = true;
        return;
      }
      const tick = () => {
        const remaining = Math.max(0, target - Date.now());
        if (!remaining) {
          clock.hidden = true;
          clearInterval(this.timer);
          return;
        }
        clock.querySelector('[data-days]').textContent = Math.floor(remaining / 86400000);
        clock.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600000) % 24).padStart(2, '0');
        clock.querySelector('[data-minutes]').textContent = String(Math.floor(remaining / 60000) % 60).padStart(2, '0');
      };
      tick();
      this.timer = setInterval(tick, 30000);
    }

    async addToCart(form) {
      if (form.dataset.busy === 'true') return;
      const button = form.querySelector('button[type="submit"]');
      const label = button.querySelector('[data-pndp-button-label]');
      const status = form.querySelector('.pndp-form__status');
      const originalLabel = label.textContent;
      const root = window.Shopify?.routes?.root || '/';
      const cartDrawer = document.querySelector('[ref="hdt-cart"]');
      const sectionId = cartDrawer?.sectionId || cartDrawer?.getAttribute('section-id');
      const data = new FormData(form);
      if (sectionId) {
        data.set('sections', sectionId);
        data.set('sections_url', location.pathname);
      }

      form.dataset.busy = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = this.dataset.addingLabel;
      status.hidden = true;
      status.textContent = '';

      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
        added = true;

        if (sectionId && typeof result.sections?.[sectionId] === 'string' && result.sections[sectionId].includes('cart-items-component')) {
          form.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
            resource: {},
            sourceId: String(data.get('id')),
            cartData: result,
            actionAfterATC: 'open_cart_drawer',
            source: 'product-form-component',
            data: { itemCount: Number(data.get('quantity')), sections: result.sections }
          }}));
        } else {
          location.assign(`${root}cart`);
        }
      } catch (error) {
        if (!added) {
          status.textContent = error.message === 'Failed to fetch' ? this.dataset.errorLabel : error.message;
          status.hidden = false;
        } else {
          location.assign(`${root}cart`);
        }
      } finally {
        form.dataset.busy = 'false';
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = originalLabel;
      }
    }
  }

  customElements.define('pawzi-nd-page', PawziNDPage);
})();
